import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import { Wrapper } from './Step0'
import { connect } from 'react-redux'
import { clearCalculator } from '../../../actions/calculator'
import PaperPlaneIcon from '../../UI/Icons/PaperPlaneIcon'
import AddCircleIcon from '../../UI/Icons/AddCircleIcon'
import { device } from '../../../utils/helpers'
import Typography from '../../UI/Typography'
import { Link } from 'react-router-dom'

const Content = styled.div`
  @media ${device.tablet} {
    display: flex;
    justify-content: space-between;
  }
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 42px 35px;
  background-color: #f3f3f3;
  margin-bottom: 10px;

  @media ${device.tablet} {
    width: 100%;
    margin-left: 1.0416666666666667vw;
    padding: 4.427083333333334vw;
  }
`

const ConfirmationText = styled.p`
  text-transform: uppercase;
  padding: 22px 0;
  font-family: 'BarlowSemiBold';
  line-height: 1.2em;
  font-size: 16px;

  @media ${device.tablet} {
    padding: 3.385416666666667vw 0;
    font-size: 1.25vw;
  }
`

const DisclaimerText = styled.p`
  padding-top: 30px;
  padding-bottom: 21px;
  font-family: 'BarlowSemiBold';
  font-size: 18px;
  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '18px',
      '24px'
    )
}; */}

  @media ${device.tablet} {
    padding-top: 3.125vw;
    padding-bottom: 2.604166666666667vw;
    font-size: 1.25vw;
  }

  ${'' /* @media ${device.laptopL} {
    padding-top: 60px;
    padding-bottom: 50px;
  } */}
`

const PaperPlane = styled(PaperPlaneIcon)`
  width: 75px;

  @media ${device.tablet} {
    width: 6.510416666666667vw;
  }

  ${'' /* @media ${device.laptopL} {
    width: 125px;
  } */}
`

const AddCircle = styled(AddCircleIcon)`
  width: 50px;

  @media ${device.tablet} {
    width: 3.90625vw;
  }

  ${'' /* @media ${device.laptopL} {
    width: 75px;
  } */}
`

const CreateNewText = styled.div`
  font-family: 'BarlowSemiBold';
  line-height: 1.3em;
  margin-top: 45px;
  font-size: 18px;

  ${'' /* ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      '18px',
      '24px'
    )
}; */}

  @media ${device.tablet} {
    margin-top: 4.427083333333334vw;
    font-size: 1.25vw;
    ${'' /* line-height: 1.0416666666666667vw; */}
  }

  ${'' /* @media ${device.laptopL} {
    margin-top: 85px;
  } */}
`

const Options = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 6.770833333333334vw;
  }

  ${'' /* @media ${device.laptopL} {
    margin-top: 130px;
  } */}
`

const secondary = css`
  color: ${props => props.theme.color.textPrimary || '#4d4d4d'};
  background-color: white;
`

const Button = styled(Link)`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  color: ${props => props.theme.color.textSecondary || '#fff'};
  border: 5px solid ${props => props.theme.color.borderPrimary || '#4d4d4d'};
  background-color: ${props => props.theme.color.bgDark || '#4d4d4d'};
  text-transform: uppercase;
  font-size: 16px;
  padding: 16px 28px;
  transition: all 0.5s ease;
  cursor: pointer;
  text-decoration: none;
  margin: 5px 0;

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  ${props => (props.secondary && secondary)};

  @media ${device.tablet} {
    font-size:  14px;
    padding: 1.1458333333333335vw 1.5625vw;
    margin: 0.2604166666666667vw 0;
  }

  @media ${device.laptop} {
    font-size:  1.09375vw;
    padding: 1.1458333333333335vw 1.5625vw;
    margin: 0.2604166666666667vw 0;
  }
`

const ButtonLikeLink = styled.div`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  color: ${props => props.theme.color.textSecondary || '#fff'};
  border: 5px solid ${props => props.theme.color.borderPrimary || '#4d4d4d'};
  background-color: ${props => props.theme.color.bgDark || '#4d4d4d'};
  text-transform: uppercase;
  font-size: 16px;
  padding: 16px 28px;
  transition: all 0.5s ease;
  cursor: pointer;
  text-decoration: none;
  margin: 5px 0;

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  ${props => (props.secondary && secondary)};

  @media ${device.tablet} {
    font-size:  14px;
    padding: 1.1458333333333335vw 1.5625vw;
    margin: 0.2604166666666667vw 0;
  }

  @media ${device.laptop} {
    font-size:  1.09375vw;
    padding: 1.1458333333333335vw 1.5625vw;
    margin: 0.2604166666666667vw 0;
  }
`

class Finish extends Component {
  clearCalculator () {
    // Reinitialize calculator to the default state
    this.props.clearCalculator()
  }

  render () {
    return (
      <Wrapper>
        <Content>
          <Section>
            <PaperPlane fill='#4d4d4d' />
            <ConfirmationText>
              IL TUO PREVENTIVO È STATO INVIATO.<br />
  SARAI RICONTATTATO AL <br /> PIÙ PRESTO
            </ConfirmationText>
            <Typography variant='h1' type='title'>Grazie!</Typography>
            <DisclaimerText>
              Ti ricordiamo che i costi riportati nel preventivo sono indicativi e dovranno essere confermati.
            </DisclaimerText>
            <ButtonLikeLink
              onClick={e => {
                this.clearCalculator.bind(this);
                window.location.href = 'https://noleggiocampi.it';
              }}
              // to='https://noleggiocampi.it'
              secondary
            >
              Torna Alla Home
            </ButtonLikeLink>
          </Section>

          <Section>
            <AddCircle fill='#4d4d4d' />
            <CreateNewText>
              CREA UN NUOVO<br /> PREVENTIVO:<br />SCEGLI IL CAMPO
            </CreateNewText>
            <Options>
              <Button onClick={this.clearCalculator.bind(this)} to='/noleggia/calcetto/1'>Calcetto</Button>
              <Button onClick={this.clearCalculator.bind(this)} to='/noleggia/basket/1'>Basket</Button>
              <Button onClick={this.clearCalculator.bind(this)} to='/noleggia/beach-volley/1'>Beach Volley</Button>
            </Options>
          </Section>
        </Content>
      </Wrapper>
    )
  }
}

export default connect(null, { clearCalculator })(Finish)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Finish.js